document.addEventListener('DOMContentLoaded', function () {

  var mainImg = document.getElementById('plmMainImage');
  var imgRing = document.getElementById('plmImgRing');

  // --- Entrée "wow" de la photo produit à l'arrivée sur le site ---
  if (mainImg) {
    requestAnimationFrame(function () {
      setTimeout(function () {
        mainImg.classList.add('plm-img-enter-run');
        if (imgRing) imgRing.classList.add('plm-ring-run');
      }, 150);
    });
  }

  // --- Sélecteur de couleur (variantes réelles) ---
  var variantInput = document.getElementById('plmVariantId');
  var priceEl = document.getElementById('plmPrice');
  var stickyPriceEl = document.getElementById('plmStickyPrice');
  var stickyThumbEl = document.getElementById('plmStickyThumb');
  document.querySelectorAll('.plm-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      if (swatch.disabled) return;
      var vid = swatch.getAttribute('data-variant-id');
      // Synchronise l'état actif entre le sélecteur principal ET celui de la
      // barre collante : les deux jeux de boutons partagent les mêmes
      // data-variant-id, donc on active partout le bon variant plutôt que
      // seulement le bouton cliqué.
      document.querySelectorAll('.plm-swatch').forEach(function (s) {
        var isMatch = s.getAttribute('data-variant-id') === vid;
        s.classList.toggle('is-active', isMatch);
        if (isMatch) {
          s.classList.remove('plm-swatch-punch');
          void s.offsetWidth;
          s.classList.add('plm-swatch-punch');
        }
      });
      if (variantInput) variantInput.value = vid;
      if (priceEl) priceEl.textContent = swatch.getAttribute('data-price');
      if (stickyPriceEl) stickyPriceEl.textContent = swatch.getAttribute('data-price');
      var img = swatch.getAttribute('data-img');
      if (img && mainImg) {
        mainImg.classList.remove('plm-img-punch');
        void mainImg.offsetWidth;
        mainImg.src = img;
        mainImg.classList.add('plm-img-punch');
      }
      // La miniature de la barre d'achat utilise sa propre image (détourée,
      // fond transparent), distincte de la photo principale du produit.
      var stickyImg = swatch.getAttribute('data-sticky-img');
      if (stickyImg && stickyThumbEl) stickyThumbEl.src = stickyImg;
    });
  });

  // --- Quantité ---
  var qtyInput = document.getElementById('plmQtyInput');
  var qtyMinus = document.getElementById('plmQtyMinus');
  var qtyPlus = document.getElementById('plmQtyPlus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = v;
    });
    qtyPlus.addEventListener('click', function () {
      var v = Math.min(20, (parseInt(qtyInput.value, 10) || 1) + 1);
      qtyInput.value = v;
    });
    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 20) v = 20;
      qtyInput.value = v;
    });
  }

  // --- Ajout au panier en AJAX (pas de redirection, juste l'icône qui réagit) ---
  var buyForm = document.getElementById('plmBuyForm');
  var cartFab = document.getElementById('plmCartFab');
  if (buyForm) {
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var submitter = e.submitter || buyForm.querySelector('button[type="submit"]');
      var submitButtons = Array.prototype.slice.call(
        document.querySelectorAll('#plmBuyForm button[type="submit"], [form="plmBuyForm"]')
      );

      if (submitter && submitter.disabled) return;
      submitButtons.forEach(function (b) { b.disabled = true; });

      var originalLabels = submitButtons.map(function (b) { return b.textContent; });

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(buyForm),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw d; });
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          bumpCartIcon();
          window.scrollTo({ top: 0, behavior: 'smooth' });
          submitButtons.forEach(function (b) { b.textContent = 'Ajouté ✓'; });
          setTimeout(function () {
            submitButtons.forEach(function (b, i) { b.textContent = originalLabels[i]; b.disabled = false; });
          }, 1600);
        })
        .catch(function () {
          // En cas de souci réseau/AJAX, on retombe sur le comportement natif du formulaire.
          submitButtons.forEach(function (b) { b.disabled = false; });
          buyForm.submit();
        });
    });
  }

  function updateCartCount(count) {
    if (!cartFab) return;
    var countEl = document.getElementById('plmCartCount');
    if (count > 0) {
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'plm-cart-fab__count';
        countEl.id = 'plmCartCount';
        cartFab.appendChild(countEl);
      }
      countEl.classList.remove('plm-cart-pop');
      countEl.textContent = count;
    } else if (countEl) {
      countEl.remove();
    }
  }

  function bumpCartIcon() {
    if (!cartFab) return;
    cartFab.classList.remove('plm-cart-bump');
    void cartFab.offsetWidth;
    cartFab.classList.add('plm-cart-bump');
  }

  // --- Minuteur synchronisé avec celui de la bannière du haut ---
  // Les deux minuteurs comptent à rebours jusqu'au prochain minuit (heure
  // locale du visiteur) : ils affichent donc automatiquement les mêmes
  // chiffres au même instant, sans lien direct ni stockage entre eux.
  var miniTimer = document.getElementById('plmMiniTimer');
  if (miniTimer) {
    var miniHoursEl = miniTimer.querySelector('[data-mini-hours]');
    var miniMinutesEl = miniTimer.querySelector('[data-mini-minutes]');
    var miniSecondsEl = miniTimer.querySelector('[data-mini-seconds]');

    var updateMiniTimer = function () {
      var now = new Date();
      var nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var diff = nextMidnight - now;
      var hours = Math.floor(diff / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      if (miniHoursEl) miniHoursEl.textContent = String(hours).padStart(2, '0');
      if (miniMinutesEl) miniMinutesEl.textContent = String(minutes).padStart(2, '0');
      if (miniSecondsEl) miniSecondsEl.textContent = String(seconds).padStart(2, '0');
    };

    updateMiniTimer();
    setInterval(updateMiniTimer, 1000);
  }

  // --- Badge avis client (sous le prix) → descend jusqu'aux avis ---
  var ratingBadge = document.getElementById('plmRatingBadge');
  var reviewsSection = document.getElementById('plmReviews');
  if (ratingBadge && reviewsSection) {
    ratingBadge.addEventListener('click', function (e) {
      e.preventDefault();
      reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // --- Animations au scroll ---
  var revealEls = document.querySelectorAll('.plm-reveal, .plm-hero__buy');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // --- Entrée des 3 coloris, une carte à la fois au fil du scroll ---
  // (indépendant de la section parente pour que chaque carte se déclenche
  // exactement au moment où elle arrive à l'écran, et pas toutes en même temps)
  var colorCards = document.querySelectorAll('.plm-color-card');
  if (colorCards.length) {
    if ('IntersectionObserver' in window) {
      var colorObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            colorObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
      colorCards.forEach(function (card) { colorObserver.observe(card); });
    } else {
      colorCards.forEach(function (card) { card.classList.add('is-visible'); });
    }
  }

  // --- "Retour à mes produits" : sur mobile on cible précisément le haut de
  // la photo du produit (pour voir ensuite le prix, le bouton "Ajouter au
  // panier" et les moyens de paiement juste en dessous) ; sur desktop on
  // cible précisément le logo (pas toute la section héros) pour arriver
  // pile en haut, sans faire apparaître le bloc prix/compteur/panier. ---
  var plmBackLink = document.getElementById('plmFinalBack');
  var plmProductAnchor = document.getElementById('plmProductAnchor');
  var plmDesktopLogo = document.querySelector('.plm-hero__logo-desktop');
  var plmHero = document.getElementById('plmHero');
  if (plmBackLink && plmProductAnchor) {
    plmBackLink.addEventListener('click', function (e) {
      e.preventDefault();
      var isDesktop = window.innerWidth >= 860;
      var target = isDesktop ? (plmDesktopLogo || plmHero) : plmProductAnchor;
      var offset = isDesktop ? 16 : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      if (history.pushState) history.pushState(null, '', '#' + (target.id || 'plmHero'));
    });
  }

  // --- Entrée logo/titre du hero : au chargement de la page (pas au scroll),
  //     identique sur mobile et PC ---
  var plmHero = document.querySelector('.plm-hero');
  if (plmHero) {
    setTimeout(function () { plmHero.classList.add('plm-hero-anim-run'); }, 150);
  }

  // --- Maquettes 3D interactives (glisser à la souris ou au doigt) ---
  function bindTilt(el) {
    var maxRot = 20;
    var state = { dragging: false, locked: null, startX: 0, startY: 0, baseX: 0, baseY: 0, curX: 0, curY: 0 };
    var rafId = null;
    var pendingRot = null;

    function clamp(v) { return Math.max(-maxRot, Math.min(maxRot, v)); }

    function apply(rotX, rotY) {
      el.style.transform = 'perspective(1200px) rotateX(' + rotX.toFixed(2) + 'deg) rotateY(' + rotY.toFixed(2) + 'deg)';
    }

    // --- Détection "on touche vraiment l'objet" (pixel opaque) plutôt que
    // n'importe où dans le carré (qui laisse voir le fond derrière la photo) ---
    var hitImg = el.querySelector('img');
    var hitCanvas = null, hitCtx = null, hitReady = false;

    function buildHitCanvas() {
      if (!hitImg || !hitImg.naturalWidth || !hitImg.naturalHeight) return;
      try {
        hitCanvas = document.createElement('canvas');
        hitCanvas.width = hitImg.naturalWidth;
        hitCanvas.height = hitImg.naturalHeight;
        hitCtx = hitCanvas.getContext('2d', { willReadFrequently: true });
        hitCtx.drawImage(hitImg, 0, 0);
        hitReady = true;
      } catch (err) {
        // Image d'une autre origine sans CORS, ou navigateur restrictif :
        // on retombe sur l'ancien comportement (toute la zone est active).
        hitReady = false;
      }
    }

    if (hitImg) {
      if (hitImg.complete) buildHitCanvas();
      hitImg.addEventListener('load', buildHitCanvas);
    }

    // Renvoie true si le point (coordonnées écran) tombe sur un pixel
    // visible (non transparent) de la photo. Par défaut (image pas encore
    // analysable), on considère que oui, pour ne rien casser.
    function isOnPillow(clientX, clientY) {
      if (!hitImg) return true;
      var rect = hitImg.getBoundingClientRect();
      if (!rect.width || !rect.height) return true;
      var localX = clientX - rect.left;
      var localY = clientY - rect.top;
      if (localX < 0 || localY < 0 || localX > rect.width || localY > rect.height) return false;

      if (!hitReady || !hitCtx) return true;

      var nw = hitCanvas.width, nh = hitCanvas.height;
      var boxRatio = rect.width / rect.height;
      var imgRatio = nw / nh;
      var drawW, drawH, offX, offY;
      if (imgRatio > boxRatio) {
        drawW = rect.width; drawH = rect.width / imgRatio;
        offX = 0; offY = (rect.height - drawH) / 2;
      } else {
        drawH = rect.height; drawW = rect.height * imgRatio;
        offY = 0; offX = (rect.width - drawW) / 2;
      }
      if (localX < offX || localX > offX + drawW || localY < offY || localY > offY + drawH) return false;

      var px = Math.floor((localX - offX) / drawW * nw);
      var py = Math.floor((localY - offY) / drawH * nh);
      px = Math.max(0, Math.min(nw - 1, px));
      py = Math.max(0, Math.min(nh - 1, py));
      try {
        return hitCtx.getImageData(px, py, 1, 1).data[3] > 15;
      } catch (err) {
        hitReady = false; // canvas "taché" (CORS) : on abandonne ce mode pour cet élément
        return true;
      }
    }

    // On ne touche au DOM qu'une seule fois par frame d'affichage,
    // au lieu de le faire à chaque événement mousemove/touchmove : ça évite les saccades.
    function scheduleApply(rotX, rotY) {
      pendingRot = [rotX, rotY];
      if (rafId !== null) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        if (pendingRot) apply(pendingRot[0], pendingRot[1]);
      });
    }

    function start(x, y) {
      state.dragging = true;
      state.startX = x;
      state.startY = y;
      state.locked = null;
      el.classList.add('is-dragging');
    }

    function move(x, y) {
      if (!state.dragging) return;
      var dx = x - state.startX;
      var dy = y - state.startY;
      state.curX = clamp(state.baseX - dy / 4);
      state.curY = clamp(state.baseY + dx / 4);
      scheduleApply(state.curX, state.curY);
    }

    function end() {
      if (!state.dragging) return;
      state.dragging = false;
      state.locked = null;
      state.baseX = state.curX;
      state.baseY = state.curY;
      el.classList.remove('is-dragging');
    }

    apply(state.baseX, state.baseY);

    el.addEventListener('mousedown', function (e) {
      if (!isOnPillow(e.clientX, e.clientY)) return;
      start(e.clientX, e.clientY);
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener('mouseup', end, { passive: true });

    el.addEventListener('touchstart', function (e) {
      // On ignore les gestes à deux doigts (pincement) : on laisse le navigateur
      // gérer son zoom natif ailleurs, mais on ne veut pas qu'un doigt en trop
      // vienne perturber la rotation ni déclencher un zoom sur l'élément.
      if (!e.touches || e.touches.length !== 1) return;
      var t = e.touches[0];
      // On ne démarre la rotation que si le doigt touche vraiment l'objet —
      // sinon on laisse la page défiler normalement (fond nuage, espace autour, etc.).
      if (!isOnPillow(t.clientX, t.clientY)) return;
      start(t.clientX, t.clientY);
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!state.dragging) return; // pas démarré sur l'objet : on laisse le scroll natif faire son travail
      if (!e.touches || e.touches.length !== 1) {
        // Un deuxième doigt est arrivé pendant le drag : on arrête proprement
        // plutôt que de laisser une valeur incohérente provoquer un à-coup.
        end();
        return;
      }
      var t = e.touches[0];
      var dx = t.clientX - state.startX;
      var dy = t.clientY - state.startY;

      // On ne décide de l'intention du geste (faire pivoter la photo, ou
      // simplement faire défiler la page) qu'une fois qu'il y a un vrai
      // mouvement. Ça évite qu'un doigt posé sur la photo pour scroller
      // ne reste "bloqué" dessus au lieu de faire défiler la page.
      if (state.locked === null) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        // On favorise légèrement le glisser (horizontal) : il ne bascule en
        // "scroll vertical" que si le geste est clairement plus vertical
        // qu'horizontal, pour que la rotation reste facile à déclencher.
        state.locked = (Math.abs(dy) > Math.abs(dx) * 1.3) ? 'v' : 'h';
        if (state.locked === 'v') {
          // Geste vertical : intention de scroll. On relâche la rotation
          // et on laisse le navigateur défiler normalement, sans preventDefault.
          end();
          return;
        }
      }
      if (state.locked === 'v') return;

      move(t.clientX, t.clientY);
      e.preventDefault();
    }, { passive: false });
    el.addEventListener('touchend', function () {
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      end();
    });
    el.addEventListener('touchcancel', function () {
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      end();
    });
  }
  document.querySelectorAll('[data-tilt]').forEach(bindTilt);

  // --- Barre d'achat collante (affichée une fois qu'on est passé sous le
  // bouton "Ajouter au panier" d'origine, dans le hero) ---
  // Cause du bug Safari (barre visible dès le chargement, sur mobile
  // uniquement) : ce script tourne au moment de DOMContentLoaded, c'est-à-dire
  // AVANT que les images du hero (photo produit, logo...) aient fini de se
  // charger. Tant qu'elles ne sont pas chargées, la mise en page n'est pas
  // stabilisée et peut encore bouger. Sur Safari, le tout premier calcul de
  // position de l'IntersectionObserver pouvait tomber pendant cette fenêtre
  // instable et donner un résultat faux (bouton d'origine perçu comme "déjà
  // scrollé au-dessus de l'écran" alors qu'on est tout en haut de la page) ;
  // Chrome ne déclenche pas ce premier calcul au même moment, d'où la
  // différence observée entre les deux navigateurs.
  // Correctif : on ne commence à observer qu'une fois la page ENTIÈREMENT
  // chargée (événement "load" = toutes les images arrivées) et après deux
  // frames d'affichage supplémentaires, pour laisser la mise en page se
  // stabiliser avant la toute première mesure.
  var stickyBar = document.getElementById('plmStickyBar');
  var buyTrigger = document.querySelector('.plm-hero__buy .plm-cta-row');
  // Pied de page (mentions légales, politiques...) : on s'en sert pour
  // masquer la barre collante quand on arrive en bas de la page, afin que
  // ces liens restent cliquables sur mobile ET sur pc.
  var footerEl = document.querySelector('footer.footer, #shopify-section-footer');

  // NOUVEAU CORRECTIF (bug : la barre se cache par erreur quand on descend
  // puis qu'on remonte légèrement, sur Safari mobile) :
  // La version précédente utilisait IntersectionObserver, qui délègue le
  // calcul au navigateur de façon asynchrone/optimisée. Sur Safari iOS, la
  // barre d'outils du navigateur (adresse + onglets) s'agrandit ou se
  // réduit PENDANT le scroll, ce qui change la hauteur réelle de la fenêtre
  // en plein milieu du geste. IntersectionObserver recalcule alors parfois
  // l'intersection par rapport à une fenêtre qui vient de changer de
  // taille, et peut donc annoncer un état qui ne correspond plus à la
  // position réelle du bouton d'origine à l'écran — d'où la barre qui
  // disparaît à tort en remontant légèrement.
  // Correctif : on abandonne IntersectionObserver pour cette barre et on
  // mesure nous-mêmes la position exacte du bouton d'origine
  // (getBoundingClientRect) à chaque scroll ET à chaque redimensionnement
  // (le changement de barre d'outils Safari déclenche aussi un "resize"),
  // avec un calcul limité à une fois par frame d'affichage
  // (requestAnimationFrame) pour rester fluide.
  function initStickyBar() {
    if (!stickyBar || !buyTrigger) return;
    var ticking = false;
    var triggerBottomInDocument = window.scrollY + buyTrigger.getBoundingClientRect().bottom;
    var refreshTriggerPosition = function () {
      triggerBottomInDocument = window.scrollY + buyTrigger.getBoundingClientRect().bottom;
    };
    var toggleFromPosition = function () {
      var rect = buyTrigger.getBoundingClientRect();
      // PC : la position du bouton est mémorisée une fois la page stabilisée.
      // Un reveal/transform temporaire ne peut donc plus faire disparaître la
      // barre pendant un scroll rapide. Mobile conserve la logique V66.
      var visible = window.innerWidth >= 860
        ? window.scrollY > (triggerBottomInDocument + 2)
        : rect.bottom < 0;
      // Dès que le pied de page (politiques, mentions légales...) commence
      // à apparaître en bas de l'écran, on masque la barre pour ne pas
      // bloquer ces liens. Elle se réaffiche automatiquement dès qu'on
      // remonte suffisamment pour que le pied de page ne soit plus visible.
      if (visible && footerEl) {
        var footerRect = footerEl.getBoundingClientRect();
        if (footerRect.top < window.innerHeight) {
          visible = false;
        }
      }
      stickyBar.classList.toggle('is-visible', visible);
    };
    var scheduleToggle = function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { toggleFromPosition(); ticking = false; });
      }
    };
    window.addEventListener('scroll', scheduleToggle, { passive: true });
    window.addEventListener('resize', function () {
      refreshTriggerPosition();
      scheduleToggle();
    }, { passive: true });
    // Mesure initiale (au cas où la page serait déjà scrollée à l'arrivée,
    // par ex. retour en arrière du navigateur).
    toggleFromPosition();
  }

  if (stickyBar && buyTrigger) {
    var startWhenStable = function () {
      // Deux rAF imbriqués = on attend que le navigateur ait fini de peindre
      // au moins une frame complète après le chargement des images, avant de
      // faire notre toute première mesure de position.
      requestAnimationFrame(function () {
        requestAnimationFrame(initStickyBar);
      });
    };
    if (document.readyState === 'complete') {
      startWhenStable();
    } else {
      window.addEventListener('load', startWhenStable, { once: true });
    }
  }

  // --- Avis clients : défilement infini avec un vrai effet "lancer" ---
  // Position pilotée entièrement en JS (transform), avec une vitesse qui
  // persiste et ralentit naturellement après un glisser rapide — comme un
  // carrousel de jeu — puis reprend la vitesse de croisière normale une
  // fois immobile. Toucher/cliquer une carte arrête tout ; relâcher relance.
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-plm-marquee]').forEach(function (marquee) {
    var track = marquee.querySelector('.plm-review-marquee__track');
    if (!track) return;
    var reverse = marquee.classList.contains('plm-review-marquee--reverse');
    var cruiseSpeed = 26; // px/s, vitesse de croisière une fois immobile
    var cruiseDir = reverse ? 1 : -1;
    var flingBoost = 1.4; // amplifie le lancer pour un effet plus franc
    var half = 0;
    var pos = 0; // position actuelle (translateX), toujours dans ]-half, 0]
    var velocity = 0; // px/ms, vitesse du "lancer" en cours de décélération
    var dragging = false;
    var moved = false;
    var lastTime = null;
    var lastPointerX = 0;
    var samples = []; // {t, x} des ~100 dernières ms, pour mesurer le lancer

    function measure() { half = track.scrollWidth / 2; }
    measure();
    window.addEventListener('resize', measure);
    pos = reverse ? -half : 0; // point de départ cohérent avec le sens de la ligne

    function render() { track.style.transform = 'translateX(' + pos + 'px)'; }
    function wrap() {
      if (half <= 0) return;
      while (pos > 0) pos -= half;
      while (pos <= -half) pos += half;
    }
    render();

    function tick(now) {
      if (lastTime === null) lastTime = now;
      var dt = now - lastTime;
      // Si l'onglet a été en pause/arrière-plan un moment, le prochain
      // "tick" arrive avec un très grand dt : sans ce plafond, le carrousel
      // avancerait d'un coup sec (téléportation) au lieu de reprendre en
      // douceur. Ça ne change rien à la vitesse normale, ça évite juste le
      // sursaut au retour sur l'onglet.
      if (dt > 100) dt = 16;
      lastTime = now;
      if (!dragging) {
        if (Math.abs(velocity) > 0.02) {
          // Phase "lancer" : on continue sur la lancée, avec une friction
          // qui ralentit naturellement jusqu'à l'arrêt.
          pos += velocity * dt;
          velocity *= Math.pow(0.15, dt / 1000);
          if (Math.abs(velocity) < 0.02) velocity = 0;
          wrap();
          render();
        } else if (half > 0) {
          // Vitesse de croisière normale
          pos += cruiseDir * cruiseSpeed * (dt / 1000);
          wrap();
          render();
        }
      }
      requestAnimationFrame(tick);
    }
    if (!prefersReducedMotion) requestAnimationFrame(tick);

    // Glisser/toucher (Pointer Events unifie souris et doigt). Se met en
    // pause seulement pendant le geste lui-même (pas au survol de la
    // souris : sur PC, le curseur reste souvent au-dessus après avoir
    // relâché, ce qui figeait le défilement indéfiniment si la pause se
    // basait sur le survol).
    marquee.addEventListener('pointerdown', function (e) {
      dragging = true; moved = false; velocity = 0;
      lastPointerX = e.clientX;
      samples = [{ t: performance.now(), x: e.clientX }];
      marquee.classList.add('is-dragging');
      if (marquee.setPointerCapture) {
        try { marquee.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });
    marquee.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now();
      var dx = e.clientX - lastPointerX;
      if (Math.abs(dx) > 4) moved = true;
      pos += dx;
      wrap();
      render();
      lastPointerX = e.clientX;
      samples.push({ t: now, x: e.clientX });
      // Ne garder que les échantillons des ~100 dernières ms : c'est la
      // vitesse juste avant le relâchement qui doit déterminer le lancer,
      // pas la moyenne de tout le geste (qui peut avoir commencé lentement).
      while (samples.length > 2 && now - samples[0].t > 100) samples.shift();
    });
    function stopDrag() {
      if (!dragging) return;
      dragging = false;
      marquee.classList.remove('is-dragging');
      if (samples.length >= 2) {
        var first = samples[0];
        var last = samples[samples.length - 1];
        var dt = last.t - first.t;
        if (dt > 0) velocity = ((last.x - first.x) / dt) * flingBoost;
      }
    }
    marquee.addEventListener('pointerup', stopDrag);
    marquee.addEventListener('pointercancel', stopDrag);
    // Empêche le clic sur un lien à l'intérieur si l'utilisateur vient de glisser
    marquee.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });

  // --- FAQ : une seule question ouverte à la fois, avec une animation ---
  // La balise <details> reste "ouverte" en permanence côté DOM : c'est la
  // classe is-open (+ le max-height du panneau de réponse) qui pilote
  // l'affichage, ce qui permet d'animer l'ouverture ET la fermeture au lieu
  // du repli instantané natif. Ouvrir une question referme donc en douceur
  // celle qui était ouverte avant.
  var faqItems = Array.prototype.slice.call(document.querySelectorAll('.plm-faq__item'));

  function closeFaqItem(item) {
    var panel = item.querySelector('.plm-faq__panel');
    var summary = item.querySelector('summary');
    item.classList.remove('is-open');
    if (panel) panel.style.maxHeight = '0px';
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function openFaqItem(item) {
    var panel = item.querySelector('.plm-faq__panel');
    var summary = item.querySelector('summary');
    item.classList.add('is-open');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  faqItems.forEach(function (item) {
    item.open = true; // toujours "ouvert" pour le DOM ; l'affichage suit is-open
    var summary = item.querySelector('summary');
    var panel = item.querySelector('.plm-faq__panel');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    if (panel) panel.style.maxHeight = '0px';

    if (summary) {
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var wasOpen = item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) closeFaqItem(other);
        });
        if (wasOpen) {
          closeFaqItem(item);
        } else {
          openFaqItem(item);
        }
      });
    }
  });

  // Si la fenêtre est redimensionnée pendant qu'une question est ouverte
  // (le texte peut alors passer sur plus ou moins de lignes), on ajuste sa
  // hauteur pour éviter qu'elle soit coupée ou laisse un vide.
  window.addEventListener('resize', function () {
    faqItems.forEach(function (item) {
      if (item.classList.contains('is-open')) {
        var panel = item.querySelector('.plm-faq__panel');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

});

